import { render, staticRenderFns } from "./Contact-mobile.vue?vue&type=template&id=45a511b0&scoped=true"
import script from "./Contact-mobile.vue?vue&type=script&lang=js"
export * from "./Contact-mobile.vue?vue&type=script&lang=js"
import style0 from "./Contact-mobile.vue?vue&type=style&index=0&id=45a511b0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a511b0",
  null
  
)

export default component.exports